// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import displayReturnSlip from "@store/Framework/Store/Store/Pages/ReturnSlip/Handlers/DisplayReturnSlip";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);

    let returnSlipId;
    if (location && location.search) {
        const parsedQuery = parseQueryString<{ returnSlipId: string }>(location.search);
        returnSlipId = parsedQuery.returnSlipId;
    }

    return {
        returnSlipId,
    };
};

const mapDispatchToProps = {
    displayReturnSlip,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

class ReturnSlipPage extends React.Component<Props> {
    UNSAFE_componentWillMount(): void {
        if (this.props.returnSlipId) {
            this.props.displayReturnSlip({
                returnSlipId: this.props.returnSlipId,
            });
        }
    }

    render() {
        return (
            <Page>
                <Zone contentId={this.props.id} zoneName="Content" />
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ReturnSlipPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;
